import { render, staticRenderFns } from "./ThePersonalOrdersDetail.vue?vue&type=template&id=4603f048&"
import script from "./ThePersonalOrdersDetail.vue?vue&type=script&lang=js&"
export * from "./ThePersonalOrdersDetail.vue?vue&type=script&lang=js&"
import style0 from "./ThePersonalOrdersDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports